module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay"
  }, [_c('mt-header', {
    attrs: {
      "title": "我的钱包"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "showMoney"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/pay/pay.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.balance))]), _vm._v(" "), _c('p', [_vm._v("账户余额(元)")])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('router-link', {
    attrs: {
      "to": "/pay/tradeRecords"
    }
  }, [_vm._v("交易记录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/pay/withdraw',
        query: {
          money: _vm.balance
        }
      }
    }
  }, [_vm._v("提现")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd9dc30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/pay.vue
// module id = 1259
// module chunks = 1